import { IIconProps } from '~/types';
const ChfFlag = (props: IIconProps) => (
  <svg
    width={28}
    height={20}
    viewBox="0 0 28 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={28} height={20} rx={2} fill="#fff" />
    <mask
      id="a"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={28}
      height={20}
    >
      <rect width={28} height={20} rx={2} fill="#fff" />
    </mask>
    <g mask="url(#a)">
      <path fill="red" d="M0 0h28v20H0z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 12H8.333A.333.333 0 0 1 8 11.667V8.333C8 8.15 8.15 8 8.333 8H12V4.333c0-.184.15-.333.333-.333h3.334c.184 0 .333.15.333.333V8h3.667c.184 0 .333.15.333.333v3.334c0 .184-.15.333-.333.333H16v3.667c0 .184-.15.333-.333.333h-3.334a.333.333 0 0 1-.333-.333z"
        fill="#fff"
      />
    </g>
  </svg>
);
export default ChfFlag;
